import { useCreateDownloadPayoutsQueue } from "@entities/campaigns/lib/hooks/useCreateDownloadPayoutsQueue";
import { ExternalPayoutStatus } from "@shared/lib/types/briefCampains";

type DownloadPayoutsFilters = {
  externalPayoutStatuses: ExternalPayoutStatus[];
  briefIds?: string[];
};

export function useDownloadPayoutsQueue() {
  const { createDownloadPayoutsQueue, isCreating } =
    useCreateDownloadPayoutsQueue();

  const downloadPayouts = (filters: DownloadPayoutsFilters) => {
    createDownloadPayoutsQueue({
      externalPayoutStatuses: filters.externalPayoutStatuses,
      briefIds: filters.briefIds ?? [],
    });
  };

  return {
    downloadPayouts,
    isDownloading: isCreating,
  };
}
